import React from "react";
import Text from "../Text";

export default function RequireData() {
  return  <Text size={13} lineHeight={16} medium marginTop={12} color='gray'>
  ( * ) Datos Obligatorios
</Text>
}